import { Link, Navigate } from 'react-router-dom';
import { Store } from 'lucide-react';
import { useMyPassbooks } from '@/shared/lib/my-passbooks';
import { setLastPassbookId } from '@/shared/lib/last-passbook';
import { PageHeader } from '@/shared/components/page-header';
import { Card } from '@/shared/ui/card';
import { Skeleton } from '@/shared/ui/skeleton';
import { EmptyState } from '@/shared/components/empty-state';

export function SelectStorePage() {
  const { passbooks, isLoading } = useMyPassbooks();

  // Uma loja só: entra direto, como sempre foi.
  const only = !isLoading && passbooks.length === 1 ? passbooks[0] : undefined;
  if (only) {
    setLastPassbookId(only._id);
    return <Navigate to={`/loja/${only._id}`} replace />;
  }

  return (
    <>
      <PageHeader
        title="Selecione uma loja"
        description="Escolha qual loja deseja gerenciar. Depois dá para trocar pelo seletor de marca, na barra lateral."
      />
      {isLoading ? (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <Skeleton key={i} className="h-24" />
          ))}
        </div>
      ) : passbooks.length === 0 ? (
        <Card>
          <EmptyState icon={Store} title="Nenhuma loja encontrada" description="Sua conta não possui lojas vinculadas." />
        </Card>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {passbooks.map((p) => (
            <Link key={p._id} to={`/loja/${p._id}`} onClick={() => setLastPassbookId(p._id)}>
              <Card className="p-5 transition-transform duration-200 hover:-translate-y-1">
                <div className="flex items-center gap-3">
                  <span className="grid size-10 place-items-center rounded-xl bg-primary/12 text-primary">
                    <Store className="size-5" />
                  </span>
                  <span className="min-w-0">
                    <span className="block truncate font-medium">{p.organizationName ?? 'Loja'}</span>
                    <span className="block truncate text-xs text-muted-foreground">{p._id}</span>
                  </span>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      )}
    </>
  );
}
